import { fetcher } from '@commenda/utils';

export const deleteKeyPersonFromBusinessEntity = async (
  businessEntityId: number,
  personId: number
) => {
  const res = await fetcher(
    `business-entities/${businessEntityId}/persons/${personId}`,
    { method: 'DELETE' }
  );

  return res;
};

